module.exports = __webpack_public_path__ + "static/media/evidency.3878d808.png";